module.exports = __webpack_public_path__ + "static/img/riskmanagement.e99b287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/riskmanagement.png
// module id = SJNW
// module chunks = 0